
// src/App.js
import './App.css';

import React from 'react';
import Gallery from './Components/Gallery';

function App() {
  return (
    <div className="App">
      <h1>Image Gallery</h1>
      <Gallery />
    </div>
  );
}

export default App;
